// extracted by mini-css-extract-plugin
export default {"IncomingSystem":"IncomingSystem_IncomingSystem__X51Xt","top":"IncomingSystem_top__iVBr-","bottom":"IncomingSystem_bottom__-PQXw","warning":"IncomingSystem_warning__I-QDf"};